/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_S2_LinkInputs */

const en_mk_ctrl_s2_link = /** @type {(inputs: Mk_Ctrl_S2_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the benchmark`)
};

const id_mk_ctrl_s2_link = /** @type {(inputs: Mk_Ctrl_S2_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat benchmark`)
};

/**
* | output |
* | --- |
* | "See the benchmark" |
*
* @param {Mk_Ctrl_S2_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_s2_link = /** @type {((inputs?: Mk_Ctrl_S2_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_S2_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_s2_link(inputs)
	return en_mk_ctrl_s2_link(inputs)
});